import React from "react";
import { Snackbar, Alert } from "@mui/material";
import { useToastStore } from "../stores/toastStore";




export default function GlobalToast() {
  const open = useToastStore((state) => state.open);
  const message = useToastStore((state) => state.message);
  const severity = useToastStore((state) => state.severity) || "info";
  const autoHideDuration = useToastStore((state) => state.autoHideDuration);
  const hideToast = useToastStore((state) => state.hideToast);

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={hideToast}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <div>
        {open && message && (
          <Alert
            onClose={hideToast}
            severity={severity}
            variant="filled"
          >
            <div dangerouslySetInnerHTML={{ __html: message }} />
          </Alert>
        )}
      </div>
    </Snackbar>
  );
}